// Optimized Bulk Quick Add for Dawn Theme - Final Version
(function() {
  'use strict';
  
  // Prevent multiple initialization
  if (window.bulkQuickAddInitialized) return;
  window.bulkQuickAddInitialized = true;

  class BulkQuickAddManager {
    constructor() {
      this.processedInputs = new Set();
      this.eventListenersAttached = false;
      this.init();
    }

    init() {
      if (!document.querySelector('quick-add-bulk[data-carton-quantity]')) return;
      
      this.setupEventListeners();
      this.processBulkContainers();
      this.setupMutationObserver();
      console.log('✓ Bulk quick add initialized');
    }

    setupEventListeners() {
      if (this.eventListenersAttached) return;
      this.eventListenersAttached = true;

      // Plus/Minus button handling
      document.addEventListener('click', (e) => {
        const target = e.target.closest('[data-target^="increment-"], [data-target^="decrement-"]');
        if (!target) return;
        
        const container = target.closest('quick-add-bulk[data-carton-quantity]');
        if (!container) return;
        
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const isPlus = target.dataset.target.includes('increment');
        const input = container.querySelector('.quantity__input');
        const inner = parseInt(container.dataset.innerQuantity);
        const current = parseInt(input.value) || 0;
        
        if (isPlus) {
          input.value = current === 0 ? inner : current + inner;
        } else {
          input.value = Math.max(0, current - inner);
        }
        
        this.updateDisplay(container);
        return false;
      }, true);

      // Add to cart handling
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.product-form__cart-submit[data-action="add-to-cart"]');
        if (!button) return;
        
        const container = button.closest('quick-add-bulk');
        if (!container) return;
        
        e.preventDefault();
        e.stopPropagation();
        this.handleAddToCart(button, container);
      });

      // Input change handling
      document.addEventListener('input', (e) => {
        if (!e.target.classList.contains('quantity__input')) return;
        
        const container = e.target.closest('quick-add-bulk[data-carton-quantity]');
        if (container) this.updateDisplay(container);
      });
    }

    processBulkContainers() {
      const containers = document.querySelectorAll('quick-add-bulk[data-carton-quantity]');
      containers.forEach(container => {
        const variantId = container.dataset.index;
        if (this.processedInputs.has(variantId)) return;
        
        this.processedInputs.add(variantId);
        
        const input = container.querySelector('.quantity__input');
        if (input) {
          input.value = 0;
          input.removeAttribute('data-cart-quantity');
          this.updateDisplay(container);
        }
      });
    }

    updateDisplay(container) {
      const input = container.querySelector('.quantity__input');
      const quantity = parseInt(input.value) || 0;
      const cartonQty = parseInt(container.dataset.cartonQuantity);
      const variantId = container.dataset.index;

      // Update minus button state
      const minusBtn = container.querySelector(`[data-target="decrement-${variantId}"]`);
      if (minusBtn) {
        minusBtn.classList.toggle('quantity__button--disabled', quantity === 0);
        minusBtn.style.cursor = quantity === 0 ? 'not-allowed' : 'pointer';
      }

      // Update breakdown text
      const breakdown = container.querySelector('.carton-breakdown-text');
      if (breakdown) {
        breakdown.textContent = this.getBreakdownText(quantity, cartonQty);
      }
    }

    getBreakdownText(quantity, cartonQty) {
      if (quantity === 0) return '0 units';
      
      const cartons = Math.floor(quantity / cartonQty);
      const remaining = quantity % cartonQty;
      
      if (cartons > 0 && remaining > 0) {
        return `${cartons} Carton${cartons !== 1 ? 's' : ''} + ${remaining} units`;
      } else if (cartons > 0) {
        return `${cartons} Carton${cartons !== 1 ? 's' : ''}`;
      } else {
        return `${quantity} units`;
      }
    }

    async handleAddToCart(button, container) {
      const variantId = button.dataset.variantId;
      const input = container.querySelector('.quantity__input');
      const quantity = parseInt(input.value) || 0;

      if (quantity <= 0) {
        this.showButtonMessage(button, 'Please select a quantity first', 'error');
        return;
      }

      this.setButtonLoading(button, true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });

        if (response.ok) {
          this.showButtonMessage(button, '✓ Added to cart', 'success');
          input.value = 0;
          this.updateDisplay(container);
          this.updateCart();
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        this.showButtonMessage(button, 'Error - try again', 'error');
      } finally {
        this.setButtonLoading(button, false);
      }
    }

    setButtonLoading(button, isLoading) {
      button.disabled = isLoading;
      button.classList.toggle('loading', isLoading);
    }

    showButtonMessage(button, message, type) {
      const span = button.querySelector('span');
      if (!span) return;
      
      const originalText = span.textContent;
      span.textContent = message;
      button.classList.add(`button--${type}`);
      
      setTimeout(() => {
        span.textContent = originalText;
        button.classList.remove(`button--${type}`);
      }, type === 'error' ? 3000 : 2000);
    }

    async updateCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        this.updateCartIcon(cart.item_count);
        this.triggerCartEvents(cart);
        this.triggerCartNotification();
        
      } catch (error) {
        console.error('Failed to update cart:', error);
      }
    }

    updateCartIcon(itemCount) {
      const cartCountBubble = document.querySelector('.cart-count-bubble');
      const cartCountSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      const cartCountHidden = document.querySelector('.cart-count-bubble .visually-hidden');

      if (cartCountBubble) {
        // Update existing bubble
        this.updateExistingCartBubble(cartCountBubble, cartCountSpan, cartCountHidden, itemCount);
      } else if (itemCount > 0) {
        // Create new bubble
        this.createCartBubble(itemCount);
      }
    }

    updateExistingCartBubble(bubble, countSpan, hiddenSpan, itemCount) {
      if (itemCount > 0) {
        bubble.style.display = '';
        
        if (countSpan) {
          if (itemCount < 100) {
            countSpan.style.display = '';
            countSpan.textContent = itemCount;
          } else {
            countSpan.style.display = 'none';
          }
        }
        
        if (hiddenSpan) {
          hiddenSpan.textContent = `${itemCount} item${itemCount !== 1 ? 's' : ''}`;
        }
      } else {
        bubble.style.display = 'none';
      }
    }

    createCartBubble(itemCount) {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (!cartIcon) return;

      const cartCountBubble = document.createElement('div');
      cartCountBubble.className = 'cart-count-bubble';
      
      const countSpan = document.createElement('span');
      countSpan.setAttribute('aria-hidden', 'true');
      if (itemCount < 100) {
        countSpan.textContent = itemCount;
      } else {
        countSpan.style.display = 'none';
      }
      
      const hiddenSpan = document.createElement('span');
      hiddenSpan.className = 'visually-hidden';
      hiddenSpan.textContent = `${itemCount} item${itemCount !== 1 ? 's' : ''}`;
      
      cartCountBubble.appendChild(countSpan);
      cartCountBubble.appendChild(hiddenSpan);
      cartIcon.appendChild(cartCountBubble);
    }

    triggerCartEvents(cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart }, 
        bubbles: true 
      }));
    }

    triggerCartNotification() {
      const notification = document.querySelector('cart-notification');
      if (notification && window.CartNotification) {
        try {
          window.CartNotification.open();
        } catch (e) {
          console.warn('Cart notification error:', e);
        }
      }
    }

    setupMutationObserver() {
      const observer = new MutationObserver((mutations) => {
        let hasNewContainers = false;
        
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE && 
                (node.matches?.('quick-add-bulk[data-carton-quantity]') ||
                 node.querySelector?.('quick-add-bulk[data-carton-quantity]'))) {
              hasNewContainers = true;
            }
          });
        });
        
        if (hasNewContainers) {
          setTimeout(() => this.processBulkContainers(), 100);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Initialize
  function initialize() {
    if (!window.bulkQuickAddManager) {
      window.bulkQuickAddManager = new BulkQuickAddManager();
    }
  }

  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Handle section reloads
  document.addEventListener('shopify:section:load', () => {
    window.bulkQuickAddManager?.processBulkContainers();
  });

})();